exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.top[data-v-bcf0f39e] {\r\n  overflow: hidden;\r\n  width: 100%;\r\n  border-bottom: 1px solid #ccc;\r\n  font-size: 14px;\r\n  padding-bottom: 10px;\n}\n.add[data-v-bcf0f39e] {\r\n  padding-top: 20px;\n}\n.active[data-v-bcf0f39e] {\r\n  float: left;\r\n  padding: 10px 20px;\r\n  cursor: pointer;\n}\n.actives[data-v-bcf0f39e] {\r\n  color: #1890ff;\n}\r\n", ""]);

// exports
